module.exports = __webpack_public_path__ + "static/media/clipboard-list-check.227f0448.svg";